import { JsonObject } from '../../base/json';
import { PlainVersionedObject, VersionedObject, VersionedObjectHandlers } from '../../base/versioned-object';

export interface AzureConnectionSettings extends JsonObject {
    tenantId: string;
    subscriptionId: string;
    resourceGroup: string;
    virtualMachine: string;
}

/**
 * Defines the common connection settings object that is shared throughout the connection's tools.
 */
export class CommonConnectionSettings extends VersionedObject {
    private static propertyNames = {
        // TODO: add properties when needed
        azureInfo: 'azureInfo'
    };

    public get azureInfo(): AzureConnectionSettings {
        return <AzureConnectionSettings>this.getProperty(CommonConnectionSettings.propertyNames.azureInfo);
    }

    public set azureInfo(value: AzureConnectionSettings) {
        this.setProperty(CommonConnectionSettings.propertyNames.azureInfo, value);
    }

    /**
     * Getter for the latest version of the common application settings
     */
    public get latestVersion(): number {
        return 1;
    }

    constructor(objectWrapper: PlainVersionedObject, handlers: VersionedObjectHandlers) {
        super(objectWrapper, handlers);
    }

    /**
     * Attempts to upgrade the current version of the object at least one version toward the latest version.
     * if this.currentVersion is null or undefined, then the upgrade should initialize to the latest version
     * this is called iteratively until the current version is equal to the latest version
     */
    protected upgrade() {
        // For now, we dont need to do anything but initialize to the latest version.
        // NOTE: When latestVersion is updated, then we need to add logic here to upgrade old application settings objects.
        // In this case, we ALWAYS must maintain backwards and forwards compatibility. This object is shared back and forth be
        if (MsftSme.isNullOrUndefined(this.currentVersion)) {
            this.clear();
            this.azureInfo = null;
            this.currentVersion = this.latestVersion;
            return;
        } else if (this.currentVersion < this.latestVersion) {
            this.currentVersion = this.latestVersion;
        } else {
            // current version is newer than the version we know about. TODO: there may need to be handling here in the future.
        }
    }
}
